/**
 * Startseiten-Slider: Überschriftenzeilen in <span> kapseln.
 *
 * Die Redaktion pflegt im Backend nur "Zeile 1<br>Zeile 2"; jede Zeile bekommt
 * hier ihr eigenes <span>, damit das CSS (components/_swiper.scss) je Zeile einen
 * Kasten in der Akzentfarbe zeichnen und die Zeilen nacheinander einblenden kann.
 */

import { all, onDomReady } from '../utils/dom';

/**
 * @param {HTMLElement} headline h1 bzw. .h1-format (ggf. mit Link darin)
 */
function wrapLines(headline) {
    const container = headline.querySelector('a') || headline;

    if (container.querySelector('span')) {
        return; // bereits gekapselt (z. B. manuell im Backend)
    }

    let span = null;

    Array.from(container.childNodes).forEach((node) => {
        if (node.nodeName === 'BR') {
            span = null;
            return;
        }

        if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) {
            return; // Leerraum zwischen den Zeilen
        }

        if (!span) {
            span = document.createElement('span');
            container.insertBefore(span, node);
        }

        span.appendChild(node);
    });
}

onDomReady(() => {
    all('#home-slider .swiper-slide h1, #home-slider .swiper-slide .h1-format').forEach(wrapLines);
});
